import { instance } from "libs/api";

import { DaysOff } from "../../drivers.types";
import { ApiRoutesDrivers } from "./../../constants";

export const requestGetDaysOff = async (
  companyId?: string
): Promise<DaysOff> => {
  return await instance.get(ApiRoutesDrivers.DaysOff, {
    params: companyId ? { companyId } : undefined
  });
};
